export default "__VITE_ASSET__94ba8694__"